/**
 * Converts current unix date from MilliSeconds to Seconds.
 */
export const getCurrentDateUnix = () => Math.ceil(Date.now() / 1000);
